/****/
/****/ // Import assets here
/****/

export const videoFiles = {
    // sample,
    // ...
}